import { ServicesInfo, CloudServiceSource } from '@feedyou/utils'

import { useBotId } from '../../store/flow'
import { cloudServicesApi } from './cloudServicesApi'

export function useCloudServices(source: CloudServiceSource): Partial<ServicesInfo> {
  const botId = useBotId()
  return cloudServicesApi.endpoints.getCloudServices.useQuery({ botId, source })?.data || {}
}
